import { FamilyMember } from './FamilyMember'
import { ResponseModel } from './ResponseModel';

export class CreatedIndividual {
    familyMemberObj: ResponseModel<FamilyMember>;
    relationshipType: string;
    isRootMember: boolean;
}
